import { AfterContentInit, Component, ContentChildren, Input, OnDestroy, QueryList } from '@angular/core';
import { NestedDirective } from 'src/app/directives/nested/component/nested.directive';
import { FilteredNested } from 'src/app/directives/nested/utility/filtered-nested.util';
import { FileAttachment } from 'src/app/model/attachment/file-attachment.model';
import { CommentTags } from '../../enums/comment-tags.enum';
import { DEFAULT_HISTORICAL_LABEL } from '../../constants/observation-comments.constants';

@Component({
    selector: 'paetep-display-attachments',
    templateUrl: './display-attachments.component.html',
    styleUrls: ['./display-attachments.component.scss']
})
export class DisplayAttachmentsComponent implements OnDestroy, AfterContentInit {
    @ContentChildren(NestedDirective) nestedActions!: QueryList<NestedDirective>;

    @Input() observationFiles: FileAttachment[] = [];

    filteredActions?: FilteredNested;

    CommentTags = CommentTags;

    constructor() { }

    ngOnDestroy(): void {
        this.filteredActions?.complete();
    }

    ngAfterContentInit(): void {
        this.filteredActions = new FilteredNested(this.nestedActions);
    }

    getCommentLabel(file: FileAttachment) {
        if (!!file.commentLabel) {
            return file.commentLabel;
        }

        if (file.historic) {
            return DEFAULT_HISTORICAL_LABEL;
        }

        return '';
    }
}
